import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class PracticeLocationDetailsScreen extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  renderLocationDetailsSection = (location) => {

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">

        { this.renderLocationInfo(location) }
        { this.renderLocationMembersSection(location) }
        { this.renderLocationClientsSection(location) }

      </div>
    </div>
  }

  renderLocationClientsSection = (location) => {
    if (!location._id) {
      return null;
    }

    const clients = this.props.practice && this.props.practice.clients ? this.props.practice.clients : [];
    const clientRows = clients.map((client) => {
      const clientInfo  = client.user_details && client.user_details[0] ? client.user_details[0] : {};
      const location_id = location._id;
      if (clientInfo.first_name && client.provider_location && client.provider_location === location_id) {
        return <div key={client._id}>
          <span style={{ color: 'grey', fontSize: 14 }}>{ StringUtils.displayName(clientInfo) }</span>
        </div>
      }
    }).filter((row) => { return row });

    return <div className="basic-container">
        <h5>{ `Clients at ${location.name ? location.name : location.street_address}` }</h5>
        { clientRows }
    </div>
  }

  renderLocationInfo = (location) => {
    if (!location._id) {
      return null;
    }

    const title = location.name || location.street_address;
    return <div className="basic-container">
      <div className="flex-container flex-container-row flex-space-between">
        <h5>{ title }</h5>
        <input  type="submit"
                value="EDIT"
                className="button-clear-blue"
                onClick={ () => { this.props.practiceActions.selectPracticeLocationToEdit(location) }}
              />
      </div>
      <div className="flex-container flex-container-column">
        <span style={{ color: 'grey', fontSize: 14 }}>{ location.street_address }</span>
        <span style={{ color: 'grey', fontSize: 14 }}>{ location.city + ', ' + location.state + ' ' + location.zipcode }</span>
        <span style={{ color: 'grey', fontSize: 14 }}>{ 'Code: ' }<span style={{ color: '#1dc2ff', fontSize: 13 }}>{location.code.toUpperCase()}</span></span>
      </div>
    </div>
  }

  renderLocationMembersSection = (location) => {

    const members = location.members || [];

    if (members.length === 0) {
      return null;
    }

    const memberRows = members.map((member, index) => {
      return this.renderPracticeStaffRow(member, index);
    }).filter((row) => { return row });

    return <div className="basic-container">
      <h5>{ `Providers at ${location.name ? location.name : location.street_address}` }</h5>
      { memberRows }
    </div>
  }

  renderPracticeStaffRow = (member, index) => {
    if (!member) {
      return null;
    }

    const user = member.user_details && member.user_details[0] ? member.user_details[0] : {};
    const roles = member.user_roles || {};
    const roleStyle = { color: 'grey', fontSize: 13, marginTop: -3 }

    var allRolesText = '';
    var allRoles = [];

    allRoles.push(roles.admin ? 'Admin' : '');
    allRoles.push(roles.practice_manager ?  'Practice Manager' : '');
    allRoles.push(roles.practice_owner ?  'Practice Owner' : '');
    allRoles.push(roles.vet ?  'Veterinarian' : '');
    allRoles.push(roles.behaviorist ?  'Behaviorist' : '');
    allRoles.push(roles.tech ? 'Tech' : '');

    allRoles.forEach((roleText) => {
      if (allRolesText === '' && roleText !== '') {
        allRolesText = roleText;
      } else if (roleText !== '') {
        allRolesText = allRolesText + ' | ' + roleText;
      }
    })

    if (!user.first_name) {
      return null;
    }

    return <div key={index} className="flex-container flex-container-row flex-space-between" style={{ marginTop: 5, marginBottom: 5, alignItems: 'center' }}>
      <div className="flex-container flex-container-column">
        <div className="flex-container flex-container-column">
          <span style={{ color: 'grey', fontSize: 14 }}>{ StringUtils.displayName(user) }</span>
          <span className="flex-container" style={roleStyle}>
            { allRolesText }
          </span>

        </div>
      </div>
    </div>
  }

  render() {
    const selectedLocation = this.props.practice && this.props.practice.selectedLocation ? this.props.practice.selectedLocation : {};
    const location = this.props.practice && this.props.practice.locations && this.props.practice.locations[selectedLocation._id] ? this.props.practice.locations[selectedLocation._id] : selectedLocation;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Location Details" />
        { this.renderLocationDetailsSection(location) }
      </div>
    );
  }


}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeLocationDetailsScreen)
